import { useEffect } from 'react';

import { useAppDispatch } from '@/shared/lib/store';

import { useGetPatternWatchlistsQuery } from '../api/pattern-watchlist.api';
import { useSelectedPatternWatchlistId } from '../model/selectors/pattern-watchlist-selected';
import { patternWatchlistActions } from '../model/slices/pattern-watchlist.slice';

export const useAutoSelectWatchlist = () => {
    const dispatch = useAppDispatch();
    const selectedPatternWatchlistId = useSelectedPatternWatchlistId();
    const { data: watchlists = [] } = useGetPatternWatchlistsQuery();

    useEffect(() => {
        // If no watchlists do nothing
        if (!Array.isArray(watchlists) || watchlists.length === 0) {
            return;
        }

        const firstWatchlist = watchlists[0];

        // If no watchlist is selected, select the first one
        if (selectedPatternWatchlistId === null && firstWatchlist) {
            dispatch(
                patternWatchlistActions.setSelectedPatternWatchlistId(
                    firstWatchlist.id,
                ),
            );

            return;
        }

        // Check if the selected watchlist still exists
        const isSelectedWatchlistExists = watchlists.some(
            (watchlist) => watchlist.id === selectedPatternWatchlistId,
        );

        // If the selected watchlist no longer exists, select the first one
        if (!isSelectedWatchlistExists && firstWatchlist) {
            dispatch(
                patternWatchlistActions.setSelectedPatternWatchlistId(
                    firstWatchlist.id,
                ),
            );
        }
    }, [dispatch, watchlists, selectedPatternWatchlistId]);
};
